const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  //DOMAIN SERVER MỚI
  development: {
    api: "https://qhctpbienhoa-api.cgis.asia/",
    domainUserSide: "http://localhost:3000",
    domainAdminSide: "https://qhcthanhphobienhoa-admin.cgis.asia",
    domainName: "",
    doMainNameGeoServer: "https://geoserver.phutho.gov.vn/geoserver/wfs",
    doMainNameGeoServerWMS: "https://geoserver.phutho.gov.vn/geoserver/dongnai_bienhoa/wms",
    datastore: 'dongnai_bienhoa',
    gwcUrl: 'https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/'
  },
  production: {
    api: "https://qhctpbienhoa-api.cgis.asia/",
    domainUserSide: "https://qhcthanhphobienhoa.cgis.asia",
    domainAdminSide: "https://qhcthanhphobienhoa-admin.cgis.asia",
    domainName: "cgis.asia",
    doMainNameGeoServer: "https://geoserver.phutho.gov.vn/geoserver/wfs",
    doMainNameGeoServerWMS: "https://geoserver.phutho.gov.vn/geoserver/dongnai_bienhoa/wms",
    datastore: 'dongnai_bienhoa',
    gwcUrl: 'https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/'
  },

  
  // geo.cgis.asia - geo cũ
  // geo-phutho.cgis.asia -geo mới

  // //DOMAIN SERVER CŨ
  // development: {
  //   api: "https://phutho-api.cgis.asia/",
  //   domainUserSide: "http://localhost:3000",
  //   // domainAdminSide: "https://admin.phutho.cgis.asia",
  //   domainAdminSide: "http://localhost:3000",
  //   domainName: "",
  //   doMainNameGeoServer: "https://geo-phutho.cgis.asia/geoserver/wfs",
  //   doMainNameGeoServerWMS: "https://geo-phutho.cgis.asia/geoserver/wms",
  //   datastore: 'phutho',
  // },
  // production: {
  //   api: "https://phutho-api.cgis.asia/",
  //   domainUserSide: "http://phutho.cgis.asia",
  //   domainAdminSide: "https://admin.phutho.cgis.asia",
  //   domainName: "phutho.cgis.asia",
  //   doMainNameGeoServer: "https://geo-phutho.cgis.asia/geoserver/wfs",
  //   doMainNameGeoServerWMS: "https://geo-phutho.cgis.asia/geoserver/wms",
  //   datastore: 'phutho',
  // },
};

module.exports = apiEnvironment[env];
